import { render, staticRenderFns } from "./wxpay_mini.vue?vue&type=template&id=7cef69fe&scoped=true&"
import script from "./wxpay_mini.vue?vue&type=script&lang=js&"
export * from "./wxpay_mini.vue?vue&type=script&lang=js&"
import style0 from "./wxpay_mini.vue?vue&type=style&index=0&id=7cef69fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef69fe",
  null
  
)

export default component.exports